enum ThemeMode {
  DARK = 'dark',
  DEFAULT = 'default',
  LIGHT = 'light',
}

export type ThemeVersionInfo = {
  userTheme: ThemeMode;
  isLightVersion: boolean;
};

export default ThemeMode;
